import { render, staticRenderFns } from "./states-table.vue?vue&type=template&id=20ca4d70&"
import script from "./states-table.vue?vue&type=script&lang=js&"
export * from "./states-table.vue?vue&type=script&lang=js&"
import style0 from "./states-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports